import { messageSystemEventSchema } from '@bunker/shared';
import type { Message } from '@/types/api';

type Translate = (key: string, options?: Record<string, unknown>) => string;

/**
 * The text of a service message (`message.system`). New rows carry a
 * structured `systemEvent` rendered in the reader's language; older rows (and
 * anything this client doesn't know) show the stored `content`.
 */
export function systemMessageText(message: Pick<Message, 'content' | 'author' | 'systemEvent'>, t: Translate): string {
  const parsed = messageSystemEventSchema.safeParse(message.systemEvent);
  if (!parsed.success) return message.content;
  const event = parsed.data;
  switch (event.kind) {
    case 'task_done': {
      const name = message.author.displayName?.trim() || message.author.username;
      return t('cmod.task.systemDone', { name, label: event.label });
    }
  }
}
